import { motion, useMotionValue, animate } from "framer-motion";
import { useEffect, useState } from "react";

const COINS = [0, 1, 2, 3, 4];

const Coin = ({ i }) => (
  <motion.div className="pot-coin" style={{ left: `${34 + (i % 3) * 14}%` }}
    initial={{ y: 0, opacity: 0, rotateY: 0 }}
    animate={{ y: [0, 95], opacity: [0, 1, 1, 0], rotateY: 540 }}
    transition={{ duration: 1.5, delay: i * 0.9, repeat: Infinity, repeatDelay: COINS.length * 0.9 - 1.5, ease: "easeIn" }}>€</motion.div>
);

export const PotAnimation = () => {
  const [total, setTotal] = useState(0);
  const mv = useMotionValue(0);
  useEffect(() => {
    const c = animate(mv, 420, { duration: 4.5, repeat: Infinity, repeatDelay: 1.2, ease: "linear", onUpdate: (v) => setTotal(Math.round(v)) });
    return () => { c.stop(); };
  }, [mv]);
  return (
    <div className="relative h-72 w-64 overflow-hidden" data-testid="pot-animation" aria-hidden>
      {COINS.map((i) => <Coin key={i} i={i} />)}
      <div className="pot-jar absolute bottom-0 left-1/2 h-52 w-48 -translate-x-1/2">
        <div className="pot-slot" />
        <motion.div className="pot-fill" animate={{ height: `${12 + (total / 420) * 70}%` }} transition={{ duration: 0.2 }} />
        <div className="absolute inset-x-0 top-16 text-center">
          <div className="text-3xl font-extrabold text-white drop-shadow" data-testid="pot-animation-total">{total} €</div>
          <div className="px-3 text-xs font-semibold text-white/80">pour l'anniversaire de Léa</div>
        </div>
      </div>
    </div>
  );
};
